(function () {
    document.querySelectorAll('.product-tabs__inner').forEach(function (wrapper) {
      var items = wrapper.querySelectorAll('.product-tabs__item');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item) other.removeAttribute('open');
          });
        });
      });
    });

    var truncators = [];

    document.querySelectorAll('.product-tabs__read-more').forEach(function (button) {
      var wrap = button.closest('.product-tabs__truncate-wrap');
      var inner = wrap.querySelector('.product-tabs__content-inner');
      var originalHTML = inner.innerHTML;
      var expanded = false;

      function expand() {
        expanded = true;
        inner.innerHTML = originalHTML;
        inner.classList.remove('product-tabs__content-inner--truncated');
        wrap.classList.add('product-tabs__truncate-wrap--expanded');
      }

      button.addEventListener('click', expand);

      function fit() {
        if (expanded) return;

        inner.innerHTML = originalHTML;
        var firstParagraph = inner.querySelector('p');
        if (!firstParagraph) return;

        var fullText = firstParagraph.textContent.replace(/\s+/g, ' ').trim();

        var style = window.getComputedStyle(firstParagraph);
        var lineHeight = parseFloat(style.lineHeight);
        if (isNaN(lineHeight)) {
          lineHeight = parseFloat(style.fontSize) * 1.2;
        }
        var maxHeight = Math.ceil(lineHeight * 2) + 1;

        firstParagraph.style.webkitLineClamp = 'none';
        firstParagraph.style.display = 'block';
        firstParagraph.style.overflow = 'visible';
        firstParagraph.textContent = fullText;

        if (firstParagraph.scrollHeight <= maxHeight) {
          firstParagraph.style.webkitLineClamp = '';
          firstParagraph.style.display = '';
          firstParagraph.style.overflow = '';
          button.remove();
          return;
        }

        var low = 0;
        var high = fullText.length;
        var best = 0;

        while (low <= high) {
          var mid = Math.floor((low + high) / 2);
          firstParagraph.textContent = fullText.slice(0, mid).trim() + '… ';
          firstParagraph.appendChild(button);

          if (firstParagraph.scrollHeight <= maxHeight) {
            best = mid;
            low = mid + 1;
          } else {
            high = mid - 1;
          }
        }

        firstParagraph.textContent = fullText.slice(0, best).trim() + '… ';
        firstParagraph.appendChild(button);
        button.classList.add('product-tabs__read-more--ready');

        firstParagraph.style.webkitLineClamp = '';
        firstParagraph.style.display = '';
        firstParagraph.style.overflow = '';
      }

      fit();
      truncators.push(fit);
    });

    if (truncators.length) {
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          truncators.forEach(function (fit) {
            fit();
          });
        }, 150);
      });
    }
  })();
